module.exports = __webpack_public_path__ + "static/media/tese_icaro.60b51ceb.png";